module.exports = "<p><b>Afhalen</b></p>\r\n<p>Wij bieden gratis afhaalpunten verspreid in België en Nederland.</p>\r\n<p>U vindt alle afhaalpunten op de kaart. Per afhaalpunt ziet u de frequentie van de bevoorrading en wanneer er afgehaald kan worden:</p>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/i18n/shipping/nl_pre.html
// module id = 8jYM
// module chunks = 1